import { Button } from '@mui/material';
import React, { useEffect } from 'react';

function Service(props) {
	useEffect(() => {
		const adjustCardHeights = () => {
			const cards = document.querySelectorAll('.single-service-wrap');
			let maxHeight = 0;

			cards.forEach(card => (card.style.height = 'auto'));

			cards.forEach(card => {
				maxHeight = Math.max(maxHeight, card.offsetHeight);
			});

			cards.forEach(card => (card.style.height = `${maxHeight}px`));
		};

		adjustCardHeights();

		window.addEventListener('resize', adjustCardHeights);
		return () => window.removeEventListener('resize', adjustCardHeights);
	}, []);

	return (
		<div className="service-area">
			<div className="container">
				<div className="row">
					{props?.services.map((el, index) => {
						return (
							<div className="col-lg-4" key={index}>
								<div className={`single-service-wrap ${el?.highlight ? 'highlight' : ''}`}>
									<div className="thumb">
										<img src={el?.img} alt={el?.type} style={{
											filter: el.filter || 'invert(100%) brightness(90%) contrast(1)',
											width: '80px',
											height: '75px',
										}} />
									</div>
									<div className="single-service-details">
										<h4>{el?.type}</h4>
										<p>{el?.description}</p>
									</div>
									<a href={el?.navigation}><p style={{color: 'black !important',fontWeight: '600' }}>{el?.buttonName}</p></a>
									{/* <Button sx={{
										backgroundColor: "#d8b035",
										"&:hover": {
											backgroundColor: "#ffffff",
											color: "#d8b035",
										},
										borderRadius: 2,
									}}
										variant="contained"
										color="primary"
										size="large"
										onClick={() => window.location.href = el?.navigation}>
										{el?.buttonName || 'Learn More'} </Button> */}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}

export default Service;
